import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ItOpsControllerService } from 'src/app/admin-api/api/itOpsController.service';

@Component({
  selector: 'app-integrity-view',
  templateUrl: './integrity-view.component.html',
  styleUrls: ['./integrity-view.component.scss']
})
export class IntegrityViewComponent implements OnInit {
  rows: any[] = [];
  columns: string[] = [];
  loading = true;

  constructor(
    private route: ActivatedRoute,
    private itOpsService: ItOpsControllerService
  ) {}

  ngOnInit(): void {
    const id = +this.route.snapshot.paramMap.get('id')!;
    this.itOpsService.executeIntegrity(id).subscribe({
      next: (res) => {
        const data = res?.result || [];
        if (data.length > 0) {
          this.columns = data[0]['map'](
            (_: any, i: number) => `Coluna ${i + 1}`
          );
        }
        this.rows = Array.isArray(data) ? data : [data];
        this.loading = false;
      },
      error: (err) => {
        console.error('Erro ao buscar dados da integridade', err);
        this.loading = false;
      }
    });
  }
}
